import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-6 col-sm-3" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7" }
const _hoisted_4 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_5 = { class: "d-flex align-items-center disposition-card-itens" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-atm" })
], -1)
const _hoisted_7 = { class: "title style-customized-cards-dashboard" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total vendido ", -1)
const _hoisted_9 = { class: "fw-black mb-8 lh-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-dark-emphasis" }, " Do primeiro ao último dia do mês ", -1)
const _hoisted_11 = { class: "col-6 col-sm-3" }
const _hoisted_12 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7" }
const _hoisted_13 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_14 = { class: "d-flex align-items-center disposition-card-itens" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-money" })
], -1)
const _hoisted_16 = { class: "title style-customized-cards-dashboard" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Valor total atendimento ", -1)
const _hoisted_18 = { class: "fw-black mb-8 lh-1" }
const _hoisted_19 = { class: "fw-medium text-dark-emphasis" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-dark-emphasis" }, " Do primeiro ao último dia do mês ", -1)
const _hoisted_21 = { class: "col-6 col-sm-3" }
const _hoisted_22 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7" }
const _hoisted_23 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_24 = { class: "d-flex align-items-center disposition-card-itens" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-check-mark-1" })
], -1)
const _hoisted_26 = { class: "title style-customized-cards-dashboard" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Qtd. atendimentos ", -1)
const _hoisted_28 = { class: "fw-black mb-8 lh-1" }
const _hoisted_29 = { class: "col-6 col-sm-3" }
const _hoisted_30 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7" }
const _hoisted_31 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_32 = { class: "d-flex align-items-center disposition-card-itens" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-users-group" })
], -1)
const _hoisted_34 = { class: "title style-customized-cards-dashboard" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Qtd. clientes atendidos ", -1)
const _hoisted_36 = { class: "fw-black mb-8 lh-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.getPerformanceData && _ctx.getPerformanceData.cards)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("h4", _hoisted_9, " R$ " + _toDisplayString(_ctx.getPerformanceData.cards.amount_sold), 1),
                  _hoisted_10
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("h4", _hoisted_18, " R$ " + _toDisplayString(_ctx.getPerformanceData.cards.total_value), 1),
                  _createElementVNode("span", _hoisted_19, [
                    _createTextVNode(" Taxa de pagamento: "),
                    _createElementVNode("strong", null, "R$ -" + _toDisplayString(_ctx.getPerformanceData.cards.tax), 1)
                  ]),
                  _hoisted_20
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("h4", _hoisted_28, _toDisplayString(_ctx.getPerformanceData.cards.qtd_attendances), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("h4", _hoisted_36, _toDisplayString(_ctx.getPerformanceData.cards.number_of_customers_served), 1)
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}